import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Clock, Users, Heart } from 'lucide-react';

export const RecipeCard = ({ recipe, featured = false }) => {
  const { t, getLocalizedText } = useLanguage();

  const totalTime = (recipe.prep_time || 0) + (recipe.cook_time || 0);
  const imageUrl = recipe.image_data || recipe.image_url || 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=800';

  return (
    <Link 
      to={`/recipes/${recipe.id}`}
      className={`group block ${featured ? 'md:col-span-2 md:row-span-2' : ''}`}
      data-testid={`recipe-card-${recipe.id}`}
    >
      <article className="bg-card rounded-2xl overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300 border border-border/50 h-full flex flex-col">
        {/* Image */}
        <div className={`relative overflow-hidden ${featured ? 'aspect-[4/3]' : 'aspect-[3/2]'}`}>
          <img
            src={imageUrl}
            alt={`${getLocalizedText(recipe.title)} - Vegan Recipe | love4vegan`}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          {/* Badges */}
          <div className="absolute top-4 left-4 flex flex-wrap gap-2">
            <span className="px-3 py-1 bg-secondary text-secondary-foreground text-xs font-medium rounded-full">
              {t(`recipes.${recipe.category}`)}
            </span>
            {recipe.course_type && (
              <span className="px-3 py-1 bg-primary/80 text-primary-foreground text-xs font-medium rounded-full">
                {t(`recipes.${recipe.course_type}`)}
              </span>
            )}
          </div>
          {/* Heart Icon */}
          <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity">
            <div className="p-2 bg-white/80 backdrop-blur-sm rounded-full">
              <Heart className="h-4 w-4 text-secondary" />
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-5 flex-1 flex flex-col">
          <h3 className={`font-serif font-semibold text-foreground mb-2 group-hover:text-primary transition-colors ${
            featured ? 'text-2xl' : 'text-lg'
          }`}>
            {getLocalizedText(recipe.title)}
          </h3>
          
          <p className="text-foreground/60 text-sm line-clamp-2 mb-4 flex-1">
            {getLocalizedText(recipe.description)}
          </p>

          {/* Meta */}
          <div className="flex items-center gap-4 text-sm text-foreground/50">
            <div className="flex items-center gap-1">
              <Clock className="h-4 w-4" />
              <span>{totalTime} {t('recipes.minutes')}</span>
            </div>
            <div className="flex items-center gap-1">
              <Users className="h-4 w-4" />
              <span>{recipe.servings} {t('recipes.servings')}</span>
            </div>
          </div>
        </div>
      </article>
    </Link>
  );
};
